var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0ZM24.9999 7.50006C29.1499 7.50006 32.4999 10.8501 32.4999 15.0001C32.4999 19.1501 29.1499 22.5001 24.9999 22.5001C20.8499 22.5001 17.4999 19.1501 17.4999 15.0001C17.4999 10.8501 20.8499 7.50006 24.9999 7.50006ZM9.99979 34.9486C13.2248 39.7986 18.7498 42.9986 24.9998 42.9986C31.2498 42.9986 36.7748 39.7986 39.9998 34.9486C39.9248 29.9736 29.9748 27.2486 24.9998 27.2486C19.9998 27.2486 10.0748 29.9736 9.99979 34.9486Z",
    fill: "#B0B3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlaceholder);
export default __webpack_public_path__ + "static/media/account_placeholder.939d11d1.svg";
export { ForwardRef as ReactComponent };